export default "/assets/website/images/2017.jpeg?73730a91f92ab27810af216afad30d23";